import { render } from "./SiteFooter.vue?vue&type=template&id=832bb9ba&scoped=true"
import script from "./SiteFooter.vue?vue&type=script&lang=js"
export * from "./SiteFooter.vue?vue&type=script&lang=js"

import "./SiteFooter.vue?vue&type=style&index=0&id=832bb9ba&scoped=true&lang=scss"

import exportComponent from "D:\\frontend\\finans\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-832bb9ba"]])

export default __exports__